import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-client-location-selector',
  templateUrl: './client-location-selector.component.html',
  styleUrls: ['./client-location-selector.component.scss']
})
export class ClientLocationSelectorComponent implements OnInit {
  @Input() component: any;
  @Input() formDesign: any;
  @Output() onChangeEmitter: any = new EventEmitter();
  @Input() formState: any;

  options: any[] = []

  myState: any = false;

  constructor() { }

  ngOnInit() {
    if (this.formState) {
      if (this.formState.clientLocations.length) {
        this.options = this.formState.clientLocations.map((location: any, i: any) => ({
          value: JSON.stringify(location),
          label: `${location.name}, ${location.streetNumber} ${location.streetName}, ${location.locality}, ${location.state}, ${location.country} - ${location.zipcode}`
        }))
      }
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  ngOnChanges(c: any) {
    if (this.formState) {
      if (this.formState.clientLocations.length) {
        this.options = this.formState.clientLocations.map((location: any, i: any) => ({
          value: JSON.stringify(location),
          label: `${location.name}, ${location.streetNumber} ${location.streetName}, ${location.locality}, ${location.state}, ${location.country} - ${location.zipcode}`
        }))
      }
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  onChange(e: any) {
    this.onChangeEmitter.emit({
      component: this.component,
      eventType: "valueChange",
      value: e.value
    })
  }
}
